import { render, staticRenderFns } from "./evaluationDialog.vue?vue&type=template&id=5d244c24&scoped=true"
import script from "./evaluationDialog.vue?vue&type=script&lang=js"
export * from "./evaluationDialog.vue?vue&type=script&lang=js"
import style0 from "./evaluationDialog.vue?vue&type=style&index=0&id=5d244c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d244c24",
  null
  
)

export default component.exports